import React from "react";
import CloseIcon from "./icon/CloseIcon";
import "./ErrorBox.css";

class ErrorBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorShow: false,
    };

    this.handleOnClickCloseErrorBox = this.handleOnClickCloseErrorBox.bind(
      this
    );
  }

  componentDidMount() {
    this.setState({
      errorShow: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.title !== this.props.title &&
      prevProps.body !== this.props.body
    ) {
      if (this.props.title !== "" && this.props.body !== "") {
        this.setState({
          errorShow: true,
        });
      } else {
        this.setState({
          errorShow: false,
        });
      }
    }
  }

  handleOnClickCloseErrorBox() {
    this.setState({
      errorShow: false,
    });
  }

  render() {
    return (
      <div
        className={
          this.state.errorShow ? "error-box error-box-open" : "error-box"
        }
      >
        <div className="error-box-title">
          <div
            className="error-box-close"
            onClick={this.handleOnClickCloseErrorBox}
          >
            <CloseIcon />
          </div>
          <h3>{this.props.title}</h3>
        </div>
        <div className="error-box-body">
          <p>{this.props.body}</p>
        </div>
      </div>
    );
  }
}

export default ErrorBox;
